import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import moment from "moment";
import { Stack } from "@mui/system";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";

import Pagination from "components/molecules/pagination/Pagination";
import { IconButton } from "@mui/material";
import CustomModal from "components/atoms/CustomModal";
import HmoListModals from "components/molecules/settings/HmoListModals";

const Row = ({ row, onDelete, onEdit }) => {
  return (
    <TableRow
      sx={{
        "&:nth-of-type(odd)": {
          backgroundColor: "background.custom",
        },
        "&:last-child td, &:last-child th": { border: 0 },
      }}
    >
      <TableCell align="left" sx={{ color: "primary.darkGrey" }}>
        {row.name}
      </TableCell>
      <TableCell align="left" sx={{ color: "primary.darkGrey" }}>
        {row.email}
      </TableCell>
      <TableCell align="left" sx={{ color: "primary.darkGrey" }}>
        {row.address}
      </TableCell>

      <TableCell align="left" sx={{ color: "primary.darkGrey" }}>
        {moment(row?.createdAt).format("D/M/Y")}
      </TableCell>
      <TableCell align="left" sx={{ color: "primary.darkGrey" }}>
        <Stack direction={"row"} spacing={1}>
          <IconButton size="small" onClick={onEdit.bind(this, row)}>
            <EditOutlinedIcon />
          </IconButton>
          <IconButton size="small" onClick={onDelete.bind(this, row)}>
            <DeleteOutlineIcon sx={{ color: "#DB1E36" }} />
          </IconButton>
        </Stack>
      </TableCell>
    </TableRow>
  );
};

export default function HMOListTable({ data, currentPage, handlePageChange }) {
  const modalRef = React.useRef(null);
  const [selectedHmo, setselectedHmo] = React.useState(null);
  const [modalType, setmodalType] = React.useState("");

  const toggleModal = (modal) => {
    modal && setmodalType(modal);
    modalRef?.current?.handleToggle();
  };

  const onEdit = (hmo) => {
    setselectedHmo(hmo);
    toggleModal("EDIT");
  };
  const onDelete = (hmo) => {
    setselectedHmo(hmo);
    toggleModal("DELETE");
  };

  return (
    <Stack direction={"column"} sx={{ width: "100%" }} spacing={2}>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="all-stock-table">
          <TableHead>
            <TableRow>
              <TableCell align="left" sx={{ fontWeight: "bold" }}>
                HMO Name
              </TableCell>
              <TableCell align="left" sx={{ fontWeight: "bold" }}>
                Contact Email
              </TableCell>

              <TableCell align="left" sx={{ fontWeight: "bold" }}>
                Office Address
              </TableCell>
              <TableCell align="left" sx={{ fontWeight: "bold" }}>
                Date Registered
              </TableCell>
              <TableCell align="left" sx={{ fontWeight: "bold" }}>
                Actions
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.hmoList?.map((row) => (
              <Row
                key={row.name}
                row={row}
                onDelete={onDelete}
                onEdit={onEdit}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Stack sx={{ p: { xs: 0, sm: 2 }, width: "90%" }}>
        <Pagination
          currentPage={currentPage}
          totalCount={data?.count}
          pageSize={10}
          onPageChange={handlePageChange}
        />
      </Stack>

      <CustomModal
        ref={modalRef}
        childrenContSx={{
          p: 3,
          pt: 5,
          height: "fit-content !important",
          width: {
            xs: "90vw",
            sm: "60vw",
            md: `${modalType === "DELETE" ? "32vw" : "40vw"} !important`,
          },
        }}
      >
        <HmoListModals
          hmo={selectedHmo}
          modalType={modalType}
          toggleModal={toggleModal}
        />
      </CustomModal>
    </Stack>
  );
}
